import { Link } from 'react-router-dom';
import { t } from '../hooks/useT';

export function HowToPlayPage() {
  return (
    <main className="page marketing">
      <article className="marketing-article">
        <Link to="/" className="link-muted legal-back">{t('legal.back')}</Link>
        <h1>{t('howTo.title')}</h1>
        <p className="marketing-lead">{t('howTo.lead')}</p>

        <section>
          <h2>{t('howTo.principleTitle')}</h2>
          <p>{t('howTo.principleP1')}</p>
          <p>{t('howTo.principleP2')}</p>
          <p>{t('howTo.principleP3')}</p>
        </section>

        <section>
          <h2>{t('howTo.zoomTitle')}</h2>
          <p>{t('howTo.zoomP1')}</p>
          <p>{t('howTo.zoomP2')}</p>
          <ul>
            <li>{t('howTo.zoomLevel0')}</li>
            <li>{t('howTo.zoomLevel1')}</li>
            <li>{t('howTo.zoomLevel2')}</li>
            <li>{t('howTo.zoomLevel3')}</li>
            <li>{t('howTo.zoomLevel4')}</li>
          </ul>
          <p>{t('howTo.zoomP3')}</p>
        </section>

        <section>
          <h2>{t('howTo.guessTitle')}</h2>
          <p>{t('howTo.guessP1')}</p>
          <p>{t('howTo.guessP2')}</p>
          <p>{t('howTo.guessP3')}</p>
        </section>

        <section>
          <h2>{t('howTo.scoreTitle')}</h2>
          <p>{t('howTo.scoreP1')}</p>
          <p>{t('howTo.scoreP2')}</p>
          <h3>{t('howTo.scorePrecisionTitle')}</h3>
          <p>{t('howTo.scorePrecisionP')}</p>
          <h3>{t('howTo.scoreSpeedTitle')}</h3>
          <p>{t('howTo.scoreSpeedP')}</p>
          <h3>{t('howTo.scoreArchiveTitle')}</h3>
          <p>{t('howTo.scoreArchiveP')}</p>
        </section>

        <section>
          <h2>{t('howTo.modesTitle')}</h2>
          <h3>{t('howTo.modeDailyTitle')}</h3>
          <p>{t('howTo.modeDailyP')}</p>
          <h3>{t('howTo.modeArchivesTitle')}</h3>
          <p>{t('howTo.modeArchivesP')}</p>
          <h3>{t('howTo.modeLeaderboardTitle')}</h3>
          <p>{t('howTo.modeLeaderboardP')}</p>
          <h3>{t('howTo.modeTopTitle')}</h3>
          <p>{t('howTo.modeTopP')}</p>
        </section>

        <section>
          <h2>{t('howTo.accountTitle')}</h2>
          <p>{t('howTo.accountP1')}</p>
          <ul>
            <li>{t('howTo.accountPerk1')}</li>
            <li>{t('howTo.accountPerk2')}</li>
            <li>{t('howTo.accountPerk3')}</li>
          </ul>
          <p>{t('howTo.accountP2')}</p>
        </section>

        <section>
          <h2>{t('howTo.tipsTitle')}</h2>
          <p>{t('howTo.tipsP1')}</p>
          <p>{t('howTo.tipsP2')}</p>
          <p>{t('howTo.tipsP3')}</p>
        </section>

        <section>
          <h2>{t('howTo.faqTitle')}</h2>
          <h3>{t('howTo.faq1q')}</h3>
          <p>{t('howTo.faq1a')}</p>
          <h3>{t('howTo.faq2q')}</h3>
          <p>{t('howTo.faq2a')}</p>
          <h3>{t('howTo.faq3q')}</h3>
          <p>{t('howTo.faq3a')}</p>
          <h3>{t('howTo.faq4q')}</h3>
          <p>{t('howTo.faq4a')}</p>
          <h3>{t('howTo.faq5q')}</h3>
          <p>{t('howTo.faq5a')}</p>
        </section>

        <section className="marketing-cta">
          <h2>{t('howTo.ctaTitle')}</h2>
          <p>{t('howTo.ctaDesc')}</p>
          <div className="cta-row">
            <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
            <Link to="/decouvrir" className="btn secondary">{t('nav.discover')}</Link>
          </div>
        </section>
      </article>
    </main>
  );
}
